export enum AmrDealTrancheTabTypes {
    details = 'details',
    auctions = 'auctions'
}
